// extracted by mini-css-extract-plugin
export default {"container":"invitation_container__5GDQh","verifyBody":"invitation_verifyBody__GdjzV","email":"invitation_email__CQ1mT","button":"invitation_button__XgctC"};